import { BannerConfig } from "@/components/layout/PromotionalBanner";

// Banner configuration for easy management
export const BANNER_CONFIG: BannerConfig[] = [
  {
    id: "review-and-win-2025",
    imageUrl: "/marketBuzzBanner.png",
    redirectUrl: "https://www.clover.com/appmarket/apps/E99G0QGSB08BG",
    altText: "Review & Win - Leave a review to win $50 Amazon gift card",
    isActive: true,
    startDate: "2025-01-01",
    endDate: "2026-12-31",
    priority: 2
  },
  {
    id: "black-friday-2025",
    imageUrl: "/blackFridayBanner.png",
    redirectUrl: "/campaigns/broadcast",
    altText: "Black Friday Special Promotion",
    isActive: false,
    startDate: "2025-11-18",
    endDate: "2025-11-29",
    priority: 5
  },
  {
    id: "eleven-eleven-2025",
    imageUrl: "/elevenelevenBanner.png",
    redirectUrl: "/campaigns/broadcast",
    altText: "11/11 Special Promotion",
    isActive: false,
    startDate: "2025-11-01",
    endDate: "2025-11-22",
    priority: 3
  },
  {
    id: "halloween-2025",
    imageUrl: "/halloweenBanner.png",
    redirectUrl: "/campaigns/sms",
    altText: "Send SMS offers and sell out your products faster!",
    isActive: false,
    startDate: "2025-01-01",
    endDate: "2025-12-31",
    priority: 4
  },
  {
    id: "buzza-chatgpt-2025",
    imageUrl: "/buzzaBanner.png",
    redirectUrl: "https://tally.so/r/MeNgaM",
    altText: "Buzza - Your Clover Analytics in ChatGPT - Coming Soon",
    isActive: true,
    startDate: "2025-01-01",
    endDate: "2026-12-31",
    priority: 3
  },
  {
    id: "christmas-2025",
    imageUrl: "/christmasBanner.png",
    redirectUrl: "/campaigns/broadcast?type=festive",
    altText: "Santa says: send a Christmas SMS to your customers",
    isActive: false,
    startDate: "2025-12-01",
    endDate: "2025-12-31",
    priority: 1
  }
  // Add more banners here as needed
];

// Helper function to get all active banners
export const getActiveBanners = (): BannerConfig[] => {
  const now = new Date();

  const activeBanners = BANNER_CONFIG.filter((banner) => {
    if (!banner.isActive) return false;

    if (banner.startDate && new Date(banner.startDate) > now) return false;
    if (banner.endDate && new Date(banner.endDate) < now) return false;

    return true;
  });

  // Sort by priority (lower number = higher priority)
  activeBanners.sort((a, b) => (a.priority || 999) - (b.priority || 999));

  return activeBanners;
};

// Helper function to get the active banner with highest priority (for backward compatibility)
export const getActiveBanner = (): BannerConfig | null => {
  const activeBanners = getActiveBanners();
  return activeBanners.length > 0 ? activeBanners[0] : null;
};

// Helper function to check if a banner should be shown based on user preferences
export const shouldShowBanner = (
  bannerId: string,
  dismissedBanners: string[]
): boolean => {
  return !dismissedBanners.includes(bannerId);
};
